/* * @Author: Tango * @Date: 2020-04-15 19:29:30 * @Last Modified by: Tango * @Last Modified time: 2020-04-15 19:29:30
*/
<template>
  <div class="personUpload">
    <a-spin :spinning="spinning">
      <a-row type="flex">
        <div class="step">
          <a-steps :current="currentProcess" type="navigation" :style="stepStyle" @change="changeStep">
            <a-step title="填写信息及上传素材" description="">
              <div slot="icon" slot-scope="{ status }">
                <div :class="{ step_1_active: status === 'process', step_done: status === 'finish' }"></div>
              </div>
            </a-step>
            <a-step :disabled="processStatus < 1" title="提交审核" description="">
              <div slot="icon" slot-scope="{ status }">
                <div
                  :class="{
                    step_2: status === 'wait',
                    step_2_active: status === 'process',
                    step_done: status === 'finish'
                  }"
                ></div>
              </div>
            </a-step>
          </a-steps>
        </div>
      </a-row>
      <div v-show="currentProcess === 0" class="step-box step-1">
        <a-row class="form" >
          <a-col :xs="24" :md="24" :xl="24" :xxl="{ span: '24' }">
            <a-form :form="form" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }" >
              <a-form-item label="人物名称">
                <a-input
                  v-decorator="[
                    'character_name',
                    {
                      rules: [
                        { required: true, message: '请填写人物名称' },
                        { max: 20, message: '最多输入20个字符' }
                      ],
                      initialValue: material.character_name
                    }
                  ]"
                  placeholder="请填写人物名称"
                  :max-length="maxLength"
                  @change="characterNameChange"
                  style="width: 320px; height: 40px; border-radius:8px;"
                />
                <span class="ant-form-text" style="color: #999999;margin-left:16px">
                  最多输入20个字符
                </span>

              </a-form-item>
              <a-form-item label="作者名称">

                <a-input
                  v-decorator="[
                    'author_name',
                    {
                      rules: [
                        { required: true, message: '请填写作者名称' },
                        { max: 20, message: '最多输入20个字符' }
                      ],
                      initialValue: material.author_name
                    }
                  ]"
                  placeholder="请填写作者名称"
                  :max-length="maxLength"
                  @change="authorNameChange"
                  style="width: 320px; height: 40px; border-radius:8px;"
                />
                <span class="ant-form-text" style="color: #999999;margin-left:16px">
                  最多输入20个字符
                </span>

              </a-form-item>
              <a-form-item label="素材简介">

                <a-textarea
                  v-decorator="[
                    'brief',
                    {
                      rules: [
                        { required: true, message: '请填写素材简介' },
                        { max: 600, message: '最多输入600个字符' }
                      ],
                      initialValue: material.brief
                    }
                  ]"
                  placeholder="请填写素材简介"
                  :max-length="600"
                  @change="briefChange"
                  style="width: 80%; height: 150px; border-radius:8px;"
                />
                <span class="ant-form-text" style="color: #999999;margin-left:16px">

                  还可输入<i style="color:#FF7401;">{{ 600 - material.brief.length }}</i>个字符
                </span>
              </a-form-item>
              <a-form-item>

              </a-form-item>
              <div class="form-title">
                上传文件 <span class="tips">至少上传一个视角，预览图尺寸为 300*300 像素，文件大小小于 200 KB；格式为：PNG / JPG / JPEG，PSD上传完成后不可再次更改。</span>
              </div>

              <a-form-item :label="`${item.name}视角`" v-for="(item,index) in directionList" :key="index">

                <base-upload
                  @onSuccess="previewOnSuccess"
                  :clip="true"
                  :clipOption="{
                    autoCropWidth:300,
                    autoCropHeight:300,
                    fixedNumber: [1, 1]
                  }"
                  :data="{direction: index, image: item.pre}"
                  :path="materialPath"
                  class="previewUpload"
                  :limit="10*1024"
                  :class="[item.pre === ''?'before': 'success']"
                >
                  <a-button class="upload-psd" v-if="!item.pre">上传预览图</a-button>
                  <img class="preview" v-else :src="`${constv.QINIU_IMAGE_CND_URL}${item.pre}`" alt="">
                  <template slot="process" >
                    <span></span>
                  </template>
                </base-upload>
                <base-upload
                  accept=".psd"
                  @uploadRequest="psdOnChange"
                  @onSuccess="psdOnSuccess"
                  @onCancel="psdOnCancel"
                  @onError="psdOnError"
                  :limit="300*1024"
                  :clip="false"
                  :data="{direction: index,image: item.status ==='uploaded'?'': item.psd}"
                  :path="materialPath"
                  style="margin-left:16px"
                  class="previewUploadPsd"
                  :class="[item.psd === ''?'before': 'success', item.status ==='uploaded' && package_id?'disabled':'']"
                >

                  <template slot="default" slot-scope="{loading}" >
                    <a-button class="upload-psd" v-if="!item.psd"><span v-if="!loading" >{{ item.status==='error'?'重新选择':'选择素材PSD' }}</span></a-button>
                    <span v-else class="psd-icon" :class="{disabled: item.status ==='uploaded' && package_id}" ></span>
                  </template>

                </base-upload>
                <span v-if="item.status === 'success'" style="margin-left:8px" class="tips" :class="[item.status]"> <i class="icon-icon_success_16"></i>上传成功 </span>
                <span v-if="item.status === 'error'" style="margin-left:8px" class="tips" :class="[item.status]"> <i class="icon-icon_failed_16"></i>上传失败，请重新选择</span>
              </a-form-item>

              <a-form-item label="素材封面" class="cover-item" style="margin-bottom:16px">
                <div class="cover-box">
                  <upload-image
                    v-decorator="[
                      'cover_img',
                      {
                        rules: [{ required: true, message: '请上传素材封面' }],
                        initialValue: material.cover_img
                      }
                    ]"

                    @onSuccess="materialOnSuccess"
                    :clip="true"
                    :clipOption="{
                      autoCropWidth:300,
                      autoCropHeight:300,
                      fixedNumber: [1, 1]
                    }"
                    :limit="10*1024"
                    :data="material"
                    :path="materialPath"
                    :bgImg="require('../../assets/img/img_upload_120@2x.png')"
                  >
                  </upload-image>
                </div>
                <div class="tips">
                  <p >尺寸：300*300像素</p>
                  <p>大小：小于200kb</p>
                  <p>格式：PNG、JPG、JPEG</p>
                </div>
              </a-form-item>

              <div class="form-title" style="margin-left:38px">
                生成各部件 <span class="tips">部件预览图（若无相应部件，则无需上传预览图），尺寸为 300*300 像素，文件大小小于 500 KB，格式为 PNG。</span>
              </div>

              <a-form-item label="生成部件">
                <a-radio-group
                  v-decorator="[
                    'type',
                    {
                      rules: [{ required: true, message: '' }],
                      initialValue: material.generation_status,
                    },
                  ]"
                  @change="typeChange"
                  style="height: 40px; line-height: 40px"
                >
                  <a-radio :value="1">
                    <span>是</span>
                  </a-radio>
                  <a-radio :value="2">
                    <span>否</span>
                  </a-radio>
                </a-radio-group>
              </a-form-item>
              <a-form-item label="部件预览图" v-if="material.generation_status == 1">
                <div class="part-list" style="margin-right: 36px">
                  <div class="part-item" v-for="(item,index) in material.part_list" :key="index">
                    <div class="title">{{ item.title }}</div>
                    <div class="cover">
                      <upload-image

                        :addWaterImage="false"
                        :accept="'.png'"
                        @onSuccess="partOnSuccess"
                        :clip="true"
                        :clipOption="{
                          autoCropWidth:300,
                          autoCropHeight:300,
                          fixedNumber: [1, 1]
                        }"
                        :limit="500"
                        :data="item"
                        :path="materialPath"
                        :bgImg="require('../../assets/img/img_upload_120@2x.png')"
                      >
                      </upload-image>
                    </div>
                    <!-- <div class="name hide-text-1" :class="{'active': item.image}">
                      {{ item.name }}
                    </div> -->
                  </div>
                </div>
              </a-form-item>
            </a-form>
          </a-col>
        </a-row>
        <a-row>
          <a-col :offset="2">
            <div class="step-btn-list">
              <a-button type="primary" class="next-step" @click="nextStep(0)">
                下一步
              </a-button>
            </div>
          </a-col>
        </a-row>
      </div>
      <div v-show="currentProcess === 1" class="step-box step-2">
        <a-row class="form">
          <a-col :xs="24" :md="24" :xl="24" :xxl="{ span: '24' }">
            <a-form :form="form2" :label-col="{ span: 4}" :wrapper-col="{ span: 19 }">
              <a-form-item label="M Art是否为该图片公开首发网站">
                <a-col>
                  <a-radio-group
                    v-decorator="[
                      'is_first_publish',
                      {
                        rules: [{ required: true, message: '请勾选' }],
                        initialValue: material.is_first_publish
                      }
                    ]"
                    @change="isFirstChange"
                  >
                    <a-radio :value="2">是</a-radio>
                    <a-radio :value="1">否</a-radio>
                  </a-radio-group>
                </a-col>

              </a-form-item>
              <a-form-item v-if="material.is_first_publish == '1'" label="首发时间">
                <a-date-picker
                  v-decorator="[
                    'first_publish_time',
                    {
                      rules: [
                        {
                          required: material.is_first_publish == '1',
                          message: '请输入首发时间'
                        }
                      ],
                      initialValue: material.first_publish_time
                        ? this.$moment(material.first_publish_time)
                        : null
                    }
                  ]"
                  placeholder="请选择首发时间"
                  @change="publishTimeChange"
                  style="width:328px"
                />
              </a-form-item>
              <a-form-item v-if="material.is_first_publish == '1'" label="首发网站">
                <a-input
                  v-decorator="[
                    'first_publish_website',
                    {
                      rules: [
                        {
                          required: material.is_first_publish == '1',
                          message: '请填写首发网站的网址'
                        }
                      ],
                      initialValue: material.first_publish_website
                    }
                  ]"
                  placeholder="请填写首发网站的网址"
                  @change="websiteChange"
                  style="width:460px"
                />
              </a-form-item>
              <a-row>
                <a-col offset="4">
                  <a-form-item
                    :wrapper-col="{
                      xs: {
                        span: 24,
                        offset: 0
                      },
                      sm: {
                        span: 24,
                        offset: 0
                      }
                    }"
                    style="margin-bottom: 0;"
                  >
                    <a-checkbox
                      v-decorator="[
                        'agreement',
                        {
                          valuePropName: 'checked'
                        }
                      ]"
                    >
                      本人确认仔细阅读理解
                      <a @click.stop="showAgreementModal = true">
                        《原创协议》
                      </a>
                      的全部内容，同意接受上述协议的全部内容
                    </a-checkbox>
                  </a-form-item>
                </a-col>
              </a-row>
            </a-form>
          </a-col>
        </a-row>
        <a-row>
          <a-col :offset="4">
            <div class="step-btn-list">
              <a-button type="primary" class="next-step" @click="prevStep(1)">
                上一步
              </a-button>
              <a-button type="primary" class="next-step" @click="submit">
                提交
              </a-button>
            </div>
          </a-col>
        </a-row>
      </div>
      <a-progress slot="indicator" type="circle" :percent="percent" v-if="percent > 0" />
      <a-modal
        :visible="showErrorModal"
        :closable="false"
        :mask-closable="false"
        @ok="handleErrorOk"
        @cancel="handleErrorCancel"
      >
        <p style="text-align:center">
          <a-icon type="close-circle" :style="{ fontSize: '26px', color: 'red' }" />
        </p>
        <p style="text-align:center">{{ ModalText }}，提交失败</p>
        <p style="text-align:center">是否重新提交？</p>
      </a-modal>

    </a-spin>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import UploadImage from '@/components/Zpace/UploadImage/UploadImage'
import { getRandom, setLocalStorage, getLocalStorage, clearLocalStorage, dataURLtoFile } from '@/utils/util.js'
import * as qiniu from 'qiniu-js'
import BaseUpload from '@/components/Zpace/UploadImage/baseUpload.vue'
// import * as layerNameJson from '@/assets/json/zh-CN_to_orig.json'
const PSD = require('psd.js')
const _ = require('lodash')
const layerNameJson = require('@/assets/json/zh-CN_to_orig.json')
const typeJson = require('@/assets/json/forZpace_en.json')
export default {
  name: 'PersonUpload',
  components: { UploadImage, BaseUpload },
  data () {
    return {
      directionList: {
        'front_view': { name: '正面', pre: '', psd: '', status: '', percent: 0, total: 0, current: 0, loading: false },
        'side_view': { name: '侧面', pre: '', psd: '', status: '', percent: 0, total: 0, current: 0, loading: false },
        'back_view': { name: '背面', pre: '', psd: '', status: '', percent: 0, total: 0, current: 0, loading: false }
      },
      materialPath: 'resources/cloud/person/',
      maxLength: 20,
      spinning: false,
      form1: this.$form.createForm(this),
      form: this.$form.createForm(this),
      form2: this.$form.createForm(this),
      currentProcess: 0,
      stepStyle: {
        marginBottom: '0px',
        width: '550px'
      },
      material: {
        // 素材
        character_name: '',
        author_name: '',
        brief: '',
        loading: false,
        percent: 0,
        watermarked_cover_img: '',
        cover_img: '',
        generation_status: 2,
        front_view: {
          resource_path: '',
          elements_path: '',
          preview_img: '',
          watermarked_preview_img: ''
        },
        back_view: {
          resource_path: '',
          elements_path: '',
          preview_img: '',
          watermarked_preview_img: ''
        },
        side_view: {
          resource_path: '',
          elements_path: '',
          preview_img: '',
          watermarked_preview_img: ''
        },
        is_first_publish: '',
        first_publish_time: '',
        first_publish_website: '',
        part_list: []
      },
      processStatus: 0,
      percent: 0,
      timer: null,
      showErrorModal: false,
      ModalText: '',
      clickSaveBtn: false,
      showAgreementModal: false,
      showHelp: false,
      showHelpUpload: false,
      package_id: '',
      psdObservable: {}

    }
  },
  watch: {
    showAuthentication (val) {
      this.checkHelpModal()
    }
  },
  computed: {
    showAuthentication () {
      return this.$store.state.texture.helpModalStatus
    },
    getQiniuUploadToken () {
      return this.$store.state.texture.token
    },
    userInfo () {
      return this.$store.state.user.info
    }
  },
  async created () {
    this.package_id = this.$route.query.id
    const typeMap = {
      upperWear: '上衣',
      bottomWear: '下装',
      shoe: '鞋子',
      hair: '发型',
      eyes: '眼型',
      headwear: '头饰'
      // glass: '眼镜'
    }
    if (this.package_id) {
      // 如果是修改 先获取之前保存的数据
      const params = {
        id: this.package_id
      }
      this.spinning = true
      const res = (await this.$api.texture.getCharacterInfo(params)).data
      this.material = Object.assign(this.material, res)
      this.material.image = res.cover_img

      for (const key in this.directionList) {
        this.directionList[key].psd = this.material[key].resource_path
        this.directionList[key].pre = this.material[key].preview_img
        if (this.material[key].resource_path) {
          this.directionList[key].status = 'uploaded'
        }
      }
      this.spinning = false

      // 兼容ie
      this.form.setFieldsValue({
        character_name: this.material.character_name,
        author_name: this.material.author_name,
        brief: this.material.brief
      })

      for (const key in typeMap) {
        const block = this.material.front_view.elements_block.find(item => item.type == key)

        this.material.part_list.push({
          type: key,
          title: `${typeMap[key]}_预览图`,
          cover_img: block.cover_img,
          loading: false,
          percent: 0,
          image: block.cover_img,
          id: block.id
        })
      }
    } else {
      for (const key in typeMap) {
        this.material.part_list.push({
          type: key,
          title: `${typeMap[key]}_预览图`,
          cover_img: '',
          loading: false,
          percent: 0,
          image: ''

        })
      }
    }
  },
  mounted () {
    const materialData = this.getMaterialData()
    console.log(materialData)
    if (materialData && !this.package_id) {
      // 异常关闭存储
      this.$confirm({
        centered: true,
        content: '有未完成操作',
        onOk: () => {
          this.material = materialData
          for (const key in this.directionList) {
            this.directionList[key].psd = this.material[key].resource_path
            this.directionList[key].pre = this.material[key].preview_img
          }
          this.loadDataFromLocal()
        },
        cancelText: '取消',
        okText: '继续',
        onCancel: () => {
          this.clearMaterialLocal()
        }
      })
    }
  },
  methods: {
    ...mapActions(['getQiniuToken']),
    // 生成图片名字
    name () {
      return getRandom(4) + Math.floor(new Date().getTime() / 1000) + getRandom(4)
    },
    // 上传步骤
    processChange (currentProcess) {
      this.currentProcess = currentProcess
    },
    // 如果本地有数据 恢复上次记录
    loadDataFromLocal () {
      if (this.material.package_title) {
        this.processStatus = 0
        this.currentProcess = 0
      }
    },
    // 上传封面图完成
    async materialOnSuccess (response, filename, file, data) {
      this.material.cover_img = response.key
      this.saveMaterialData()
      this.form.setFieldsValue({ cover_img: response.key })
      // 上传水印图片 最终水印地址 http://wm.mindcomic.com/resources/cloud/title_image_web/fjsa1594015760ensz.png=zpace_wm_muti
      // 添加水印
      this.addWaterMark(file, this.materialPath).then(res => {
        this.material.watermarked_cover_img = res
        this.saveMaterialData()
      })
    },
    // 上传预览图成功
    previewOnSuccess ({ response, filename, file, data }) {
      this.directionList[data.direction].pre = data.image
      this.material[data.direction].preview_img = data.image
      this.saveMaterialData()
      // 添加水印
      this.addWaterMark(file, this.materialPath).then(res => {
        this.material[data.direction].watermarked_preview_img = res
        this.saveMaterialData()
      })
    },
    psdOnError (data) {
      this.directionList[data.direction].status = 'error'
    },
    // 上传psd 成功后
    psdOnSuccess ({ response, filename, file, data }) {
      this.directionList[data.direction].status = 'success'
      this.directionList[data.direction].psd = data.image

      this.material[data.direction].resource_path = data.image
      this.saveMaterialData()
    },
    psdOnCancel (data) {
      console.log(data)
      this.material[data.direction].elements_path = ''
      this.material[data.direction].resource_path = ''
      this.psdObservable.unsubscribe()
      this.saveMaterialData()
    },
    // 解析psd图层
    psdOnChange ({ action, data, file, filename }) {
      console.log(data)
      this.directionList[data.direction].psd = ''
      this.directionList[data.direction].status = ''
      var url = URL.createObjectURL(file)
      PSD.fromURL(url).then(async (psd) => {
        URL.revokeObjectURL(url) // 销毁实例
        // 获取psd图层信息包括 组和图层
        const psdDataList = psd.tree().descendants()
        // 素材切片
        const spineSlices = {}
        const layerList = []
        // 保存切片信息
        const slices = {}
        for (let i = 0; i < psdDataList.length; i++) {
          const layer = psdDataList[i]
          // 先找出黑框的宽高和xy坐标
          if (layer.type === 'layer' && layer.parent.name === '分区') {
            spineSlices[_.trim(layer.name)] = {
              name: _.trim(layer.name),
              x: layer.left,
              y: layer.top,
              width: layer.width,
              height: layer.height
            }
            // 是否有图像数据
            // if (layer.width > 0) {
            //   console.log(layer, layerNameJson, layer.layer.visible)
            //   const img = dataURLtoFile(layer.layer.image.toBase64(), file.name)
            //   // 是否跟 部位json 文件匹配上
            //   if (layerNameJson[_.trim(layer.name)]) {
            //     this.postImage(img, this.materialPath).then(res => {
            //       slices[layerNameJson[_.trim(layer.name)]] = res
            //     })
            //   }
            // }
          } else if (layer.type === 'layer' && layer.parent.name === '角色') {
            // 实际的切片
            layerList.push(layer)
          }
        }
        console.log(layerList, spineSlices)

        layerList.forEach((item, index) => {
          item.name = _.trim(item.name)

          if (item.width > 0) {
            if (spineSlices[item.name]) {
              this.toSpineImage(item.layer.image.toBase64(), {
                sWidth: spineSlices[item.name].width,
                sHeight: spineSlices[item.name].height,
                x: item.left - spineSlices[item.name].x,
                y: item.top - spineSlices[item.name].y,
                width: item.width,
                height: item.height
              }).then(res => {
                const img = dataURLtoFile(res, file.name)
                // 是否跟 部位json 文件匹配上
                if (layerNameJson[item.name]) {
                  this.directionList[data.direction].total += 1
                  this.postImage(img, this.materialPath).then(res => {
                    console.log(index, layerList.length)
                    this.directionList[data.direction].loading = true
                    this.directionList[data.direction].current += 1
                    this.directionList[data.direction].percent = Math.floor((this.directionList[data.direction].current / this.directionList[data.direction].total) * 100)
                    if (this.directionList[data.direction].percent === 100) this.directionList[data.direction].loading = false
                    slices[layerNameJson[item.name]] = res
                    item = null // 防止内存泄漏
                    // document.querySelector('#image').appendChild(item.layer.image.toPng())
                  })
                }
              })
            } else {
              console.log(item.name, '图层名字匹配不上')
            }
          } else {
            console.log(item, 'psd图层隐藏或者没有像素')
          }
        })

        this.material[data.direction].elements_path = slices
        this.saveMaterialData()
      }).catch(err => console.log(err))
    },
    // 生成H5编辑器字段
    sliceTypeByName (elementPath) {
      return new Promise((resolve, reject) => {
        this.$third.get(`${this.constv.QINIU_IMAGE_CND_URL}` + elementPath).then(res => {
          const list = res.data
          const block = []
          this.material.part_list.forEach(item => {
            const type = typeJson.replacement[item.type]
            const sliceMap = {}
            type && type.forEach(slice => {
              if (list[slice]) sliceMap[slice] = list[slice]
            })
            console.log(type, sliceMap, '=============')
            if (Object.keys(sliceMap).length > 0) {
              block.push({
                id: item.id || undefined,
                type: item.type,
                cover_img: item.cover_img,
                elements: {
                  ...sliceMap
                }
              })
            }
          })

          resolve(block)
        })
      })
    },
    /**
     * @param sWidth // 黑框宽
     */
    // 生成spine 里面插槽实际图片的尺寸大小
    toSpineImage (base64, { sWidth, sHeight, x, y, width, height }) {
      let canvas = document.createElement('canvas')
      var image = new Image()
      canvas.width = sWidth
      canvas.height = sHeight
      const ctx = canvas.getContext('2d')

      image.src = base64
      image.crossOrigin = 'Anonymous'
      return new Promise((resolve, reject) => {
        image.onload = () => {
          ctx.drawImage(image, x, y)
          resolve(canvas.toDataURL())
          canvas = null
        }
      })
    },
    // 获取后缀名
    geteExtension (url) {
      var ext = null
      var name = url.toLowerCase()
      var i = name.lastIndexOf('.')
      if (i > -1) {
        ext = name.substring(i)
      }
      return ext
    },
    // 根据图片后缀名判断素材类型（贴图，场景）
    checkImgType (url) {
      const arr = ['.jpg', '.jpeg', '.jpe', '.jfif', '.jif']
      const ext = this.geteExtension(url)
      console.log(ext, 'ext')
      if (['.png'].includes(ext)) {
        return '2'
      } else if (arr.includes(ext)) {
        return '1'
      }
    },
    // 点击下一步
    nextStep (step) {
      switch (step) {
        case 0:
          this.form.validateFields((error, values) => {
            if (error) {
              return
            }
            if ((this.material.front_view.resource_path === '' || this.material.front_view.preview_img === '' || this.directionList.front_view.loading) &&
              (this.material.side_view.resource_path === '' || this.material.side_view.preview_img === '' || this.directionList.side_view.loading) &&
              (this.material.back_view.resource_path === '' || this.material.back_view.preview_img === '' || this.directionList.back_view.loading)) {
              this.$message.error('至少上传一个视角')
              return false
            }

            for (const key in this.directionList) {
              if (this.directionList[key].pre !== '' && this.directionList[key].psd === '') {
                this.$message.error(`请上传${this.directionList[key].name}视角的psd文件`)
                return false
              } else if (this.directionList[key].pre === '' && this.directionList[key].psd !== '') {
                this.$message.error(`请上传${this.directionList[key].name}视角的预览图`)
                return false
              }
            }

            this.currentProcess = step - 0 + 1
            this.processStatus = 1
          })
          break
      }
    },
    prevStep (step) {
      this.currentProcess = step - 0 - 1
    },
    // 上传到七牛
    async postJson (json) {
      json = new Blob([JSON.stringify(json)], { type: 'application/json' })
      const path = this.materialPath
      const sendData = {
        action: 'upload',
        bucketType: '1'
      }
      // 获取七牛上传token
      await this.getQiniuToken(sendData)

      const params = {
        token: this.$store.state.texture.token,
        key: `${path}${this.name()}.${
          json.type.split('/')[1]
        }`
      }
      return new Promise((resolve, reject) => {
        // 上传到七牛 拿到图片地址
        const observable = qiniu.upload(json, params.key, params.token)
        observable.subscribe({
          next: (result) => {

          },
          error: () => {
            this.$message.error('上传json失败')
            reject(new Error('上传json失败'))
          },
          complete: async (response) => {
            resolve(response.key) // 返回的路径
          }
        })
      })
    },
    // 上传图片到七牛
    async postImage (file, path) {
      const sendData = {
        action: 'upload',
        bucketType: '1'
      }
      // 获取七牛上传token
      await this.getQiniuToken(sendData)

      const params = {
        token: this.$store.state.texture.token,
        key: `${path}${this.name()}.${
          file.type.split('/')[1]
        }`
      }
      return new Promise((resolve, reject) => {
        // 上传到七牛 拿到图片地址
        const observable = qiniu.upload(file, params.key, params.token)
        this.psdObservable = observable.subscribe({
          next: (result) => {

          },
          error: () => {
            this.$message.error('上传图片失败')
            reject(new Error('上传图片失败'))
          },
          complete: async (response) => {
            resolve(response.key) // 返回的路径
          }
        })
      })
    },
    // 添加水印
    async addWaterMark (file, path) {
      // 生成水印名字
      const waterMarkKey = `${path}${this.name()}.${
        file.type.split('/')[1]
      }`
      // 上传水印图片
      const sendData = {
        action: 'upload',
        bucketType: '2'
      }
      await this.getQiniuToken(sendData)
      return new Promise((resolve, reject) => {
        // 上传到七牛 拿到图片地址
        const observable = qiniu.upload(file, waterMarkKey, this.$store.state.texture.token)
        observable.subscribe({
          next: (result) => {
          // 主要用来展示进度
          },
          error: () => {
            this.$message.error('上传水印图片失败')
            reject(new Error('上传水印图片失败'))
          },
          complete: (response) => {
            // 返回的路径
            resolve(response.key)
          }
        })
      })
    },
    changeStep (step) {
      this.currentProcess = step
    },
    // 发布
    submit () {
      this.form2.validateFields(async (error, values) => {
        if (error) {
          return
        }
        if (!values.agreement) {
          this.$message.error('请阅读并勾选协议')
          return
        }

        this.spinning = true
        this.percent = 0
        this.timer = setInterval(() => {
          this.percent += 10
          if (this.percent >= 90) clearInterval(this.timer)
        }, 100)
        this.material.is_first_publish = values.is_first_publish
        this.material.first_publish_website = values.first_publish_website

        const sendData = _.cloneDeep(this.material)

        if (this.package_id) {
          if (sendData.generation_status == 1) {
            sendData.front_view.elements_block = await this.sliceTypeByName(sendData.front_view.elements_path)
            sendData.side_view.elements_block = await this.sliceTypeByName(sendData.side_view.elements_path)
            sendData.back_view.elements_block = await this.sliceTypeByName(sendData.back_view.elements_path)
          }
        } else {
          if (sendData.front_view.resource_path) {
            sendData.front_view.elements_path = await this.postJson(sendData.front_view.elements_path)
            if (sendData.generation_status == 1) {
              sendData.front_view.elements_block = await this.sliceTypeByName(sendData.front_view.elements_path)
            }
          }
          if (sendData.side_view.resource_path) {
            sendData.side_view.elements_path = await this.postJson(sendData.side_view.elements_path)
            if (sendData.generation_status == 1) {
              sendData.side_view.elements_block = await this.sliceTypeByName(sendData.side_view.elements_path)
            }
          }
          if (sendData.back_view.resource_path) {
            sendData.back_view.elements_path = await this.postJson(sendData.back_view.elements_path)
            if (sendData.generation_status == 1) {
              sendData.back_view.elements_block = await this.sliceTypeByName(sendData.back_view.elements_path)
            }
          }
        }

        sendData.front_view = JSON.stringify(sendData.front_view)
        sendData.side_view = JSON.stringify(sendData.side_view)
        sendData.back_view = JSON.stringify(sendData.back_view)
        sendData.category = 1 // '1:人物 2动作'
        delete sendData.percent
        delete sendData.loading
        delete sendData.error
        delete sendData.image
        delete sendData.part_list
        if (this.package_id) sendData.id = this.package_id
        await this.$api.texture
          .submitCharacterEdit(sendData)
          .then(res => {
            if (res.status && res.status === 'error') {
              this.ModalText = res.message.message
              this.showErrorModal = true
            } else {
              this.percent = 100
              this.$message.success('提交素材成功！')
              this.clearMaterialLocal()
              this.clickSaveBtn = true
              this.$router.push('/manage/person')
            }
          })
          .catch(err => {
            clearInterval(this.timer)
            this.spinning = false
            if (err && err.response) {
              switch (err.response.status) {
                case 400:
                  err.message = '请求错误(400)'
                  break
                case 401:
                  err.message = '未授权，请重新登录(401)'
                  break
                case 403:
                  err.message = '拒绝访问(403)'
                  break
                case 404:
                  err.message = '请求出错(404)'
                  break
                case 408:
                  err.message = '请求超时(408)'
                  break
                case 500:
                  err.message = '服务器错误(500)'
                  break
                case 501:
                  err.message = '服务未实现(501)'
                  break
                case 502:
                  err.message = '网络错误(502)'
                  break
                case 503:
                  err.message = '服务不可用(503)'
                  break
                case 504:
                  err.message = '网络超时(504)'
                  break
                case 505:
                  err.message = 'HTTP版本不受支持(505)'
                  break
                default:
                  err.message = `连接出错(${err.response.status})!`
              }
            } else {
              err.message = '连接服务器失败!'
            }
            this.ModalText = err.message
            this.showErrorModal = true
          })
      })
    },
    isFirstChange (e) {
      this.material.is_first_publish = e.target.value
      if (e.target.value === 1) {
        this.material.first_publish_time = ''
        this.material.first_publish_website = ''
      }
    },
    characterNameChange (e) {
      this.material.character_name = e.target.value
      this.saveMaterialData()
    },
    authorNameChange (e) {
      this.material.author_name = e.target.value
      this.saveMaterialData()
    },
    briefChange (e) {
      this.material.brief = e.target.value
      this.saveMaterialData()
    },
    websiteChange (e) {
      this.material.first_publish_website = e.target.value
      this.saveMaterialData()
    },
    publishTimeChange (date, dateString) {
      this.material.first_publish_time = dateString
      this.saveMaterialData()
    },
    // 保存数据到本地
    saveMaterialData () {
      setLocalStorage(`personMaterial_${this.userInfo.user_id}`, JSON.stringify(this.material))
    },
    // 清楚本地素材数据
    clearMaterialLocal () {
      clearLocalStorage(`personMaterial_${this.userInfo.user_id}`)
    },
    getMaterialData () {
      return JSON.parse(getLocalStorage(`personMaterial_${this.userInfo.user_id}`))
    },
    // 提交错误弹窗确认
    handleErrorOk () {
      this.showErrorModal = false
      this.spinning = false
      this.submit()
    },
    // 提交错误弹窗取消
    handleErrorCancel () {
      this.showErrorModal = false
      this.spinning = false
    },
    // 打开帮助页面
    showHelpModal () {
      this.showHelp = true
    },
    checkFirst (rule, value, callback) {
      if (value === '1' || value === '2') {
        callback()
      } else {
        const err = '请勾选'
        callback(err)
      }
    },
    typeChange (e) {
      this.material.generation_status = e.target.value
    },
    partOnSuccess (response, filename, file, data) {
      data.name = filename
      data.cover_img = response.key
      this.saveMaterialData()
    }
  }
}
</script>

<style lang="less" scoped>
.previewUploadPsd{
  margin: 0;
  border-radius: 0;
  &.disabled {
    /deep/
    .ant-upload{
      pointer-events: none;
    }
  }
  /deep/
  .ant-upload{
    border-radius: 4px !important;
  }
  /deep/
  .upload-btn{
    padding: 0 6px !important;
  }
  &.before{
    width: 115px;
    height: 40px;
  }
  &.success{
    width: 36px;
    height: 40px;

  }
  /deep/
  .preview {
    width: 40px;
    height: 40px;
    border: 1px solid #CCCCCC;
    border-radius: 8px;
  }
}
.previewUpload {
  margin: 0;
  &.before{
    width: 115px;
    height: 40px;
  }
  &.success{
    width: 40px;
    height: 40px;
  }
  /deep/
  .preview {
    width: 40px;
    height: 40px;
    border: 1px solid #CCCCCC;
    border-radius: 8px;
  }
}
.showHelpUpload{
.title {
    color: @primary-color;
    text-align: center;
    font-size: 24px;
  }

  .ant-modal-body{
    padding: 0 44px;
    color: #343434;
    font-size: 16px;
    p {
      line-height: 28px;
    }
    img {
      width: 100%;
      height: auto;
    }
    .content {
    }
    .btn-list{
      text-align: center;
      margin-top: 32px;
    }
  }
}
.upload-max {
  width: 120px;
  height: 120px;
  border-radius: 8px;
  overflow: hidden;
  background-image: url('../../assets/img/img_upload_120@2x.png');
  background-size: 100% 100%;
  background-color: #fafafa;
  border: 1px dashed #d9d9d9;
  cursor: pointer;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 99;
}
.help-content {
  img {
    display: inline-block;
    width: 100%;
    height: auto;
  }
  .title {
    color: @primary-color;
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 30px;
  }
  .desc {
    font-size: 14px;
    color: #999999;
    margin-bottom: 25px;
  }
  .img-list {
    display: flex;
    align-items: center;
    height: 200px;
    .img {
      max-width: 200px;

      margin-right: 25px;
      img {
        display: block;
        width: 100%;
        height: auto;
      }
    }
  }
}ant-form-item-control
#image {
    img {
      width: 100px;
      height: auto;
    }
  }
.personUpload {
  background-color: #ffffff;

  /deep/
  .ant-form-item-children{
    display: flex;
    .tips {
      i {
        margin-right: 4px;
      }
      &.success {
        color: #6CAE4C;
      }
      &.error {
        color: #F5222D;
      }
    }
  }
  .ant-btn-link {
    color: @primary-color;
    background-color: transparent;
    border-color: transparent;
    -webkit-box-shadow: none;
    box-shadow: none;
  }
  .step {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 30px;
    border-bottom: 1px solid #f2f2f2;
    /deep/ .ant-steps-navigation .ant-steps-item-container {
      padding-bottom: 22px;
      padding-top: 22px;
      width: 100%;
      margin-left: 0;
    }
    /deep/ .ant-steps-item-icon {
      margin-right: 12px;
    }
    /deep/ .ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item {
      margin-right: 156px;
    }
    /deep/ .ant-steps-navigation .ant-steps-item::after {
      margin-top: -4px;
      width: 116px;
      height: 6px;
      left: initial;
      right: -192px;
      background-image: url('../../assets/img/img_line_116_6@2x.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      transform: none;
      border: none;
      transform: translateX(-50%);
    }
  }
  .step-box {
    background: #fff;
    padding: 40px 0px;
    min-height: 600px;
    .upload-psd {
      width: 115px;
      height: 40px;
      border-radius: 8px;
      margin-right: 16px;
    }
    .element-box {
      padding: 0 0 30px;
      border-bottom: 1px solid #f2f2f2;
      margin-bottom: 30px;
      .element-list {
        display: flex;
        .element-item {
          width: 120px;
          height: 120px;
          margin-right: 20px;
          text-align: center;
          box-sizing: border-box;
          position: relative;
          border-radius: 8px;
          border: 1px solid #f2f2f2;
          background-color: #fafafa;
          cursor: pointer;
          &.none {
            display: none;
          }
          &:hover {
            .mask {
              display: block;
              .del-btn {
                display: block;
                position: absolute;
                top: 3px;
                right: 3px;
                z-index: 9;
              }
            }
          }
          .mask {
            display: none;
            position: absolute;
            border-radius: 4px;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            // background-color: rgba(0, 0, 0, 0);

            justify-content: flex-end;

            .del-btn {
              display: none;
              color: red;
              cursor: pointer;
            }
          }
          &.hasImg.active {
            border: 1px solid @primary-color;
          }
          &.active {
            // color: #1890ff;
            border: 1px dashed @primary-color;
            &::after {
              position: absolute;
              content: '';
              display: block;
              width: 100%;
              height: 2px;
              background-color: @primary-color;
              bottom: -32px;
              left: 0;
            }
            &::before {
              position: absolute;
              content: '';
              display: block;
              width: 10px;
              height: 4px;
              background-image: url('../../assets/img/icon_subscript_10_4@2x.png');
              background-size: 100% 100%;
              background-repeat: no-repeat;
              bottom: -36px;
              left: 50%;
              transform: translateX(-50%);
            }
          }
          .name {
            width: 100%;
            height: 30px;
            text-align: center;
            line-height: 30px;
            position: absolute;
            bottom: 0;
            left: 0;
            background-color: rgba(0, 0, 0, 0.5);
            color: #fff;
            border-radius: 0 0 8px 8px;
          }
          .cover {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #bbbbbb;
            overflow: hidden;
            border-radius: 8px;
            img {
              display: block;
              border-radius: 8px;
              width: 100%;
              height: auto;
            }
          }
        }
        .add-btn {
          position: relative;
          width: 120px;
          min-height: 120px;
          border-radius: 8px;
          border: 1px solid rgba(229, 229, 229, 1);
          background-color: #f2f2f2;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          background-image: url('../../assets/img/img_add_material_120@2x.png');
          background-size: 100% 100%;
          background-repeat: no-repeat;
          .text {
            position: absolute;
            bottom: 15px;
            font-size: 14px;
            width: 100%;
            text-align: center;
            color: #bbbbbb;
          }
          &:hover {
            border: 1px solid @primary-color;
          }
        }
      }
      .list-empty {
        width: 100%;
        margin-bottom: 40px;
        p {
          color: #999999;
        }
      }
    }
    .step-btn-list {
      margin-top: 40px;
      margin-left: 15px;
      .next-step {
        margin-right: 20px;
      }
    }
    .form-title {
      margin-top: 42px;
      margin-left: 56px;
      padding-left: 12px;
      margin-bottom: 35px;
      position: relative;
      color: #333333;
      font-size: 16px;
      display: flex;
      align-items: center;
      &::after {
        display: block;
        content: '';
        width: 4px;
        height: 12px;
        background-color: @primary-color;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        border-radius: 8px;
      }
      .tips {
        margin-left: 10px;
        font-size: 12px;
        color: #999999;
      }
    }
  }
  /deep/ .cover-item {

    .ant-form-item-children {
      display: flex;
      align-items: center;
      .cover-box {
        width: 120px;
        height: 120px;
        position: relative;
        overflow: hidden;
        &:hover {
          .mask {
            display: flex;
            .upload-btn {
              display: block;
            }
          }
        }
        .mask {
          display: none;
          border-radius: 4px;
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.5);

          justify-content: center;
          align-items: center;
          pointer-events: none;
          .upload-btn {
            display: none;
            pointer-events: none;
          }
        }
      }
      .tips {
        font-size: 12px;
        margin-left: 20px;
        p {
          margin: 0;
          line-height: 1;
          margin-bottom: 14px;
          color: #999999;
        }
      }
    }
  }

}

.part-list {
  width: 100%;
  display: grid;
 justify-content: space-between;
  grid-template-columns: repeat(auto-fill, 140px);
  grid-gap: 24px;
  border: 1px solid #F2F2F2;
  border-radius: 8px;
  padding: 24px;
  .part-item {
    .title{
      font-size: 12px;
      color: #BBBBBB;
      line-height: 1;
      margin-bottom: 16px;
    }
    .cover {
       width: 120px;
      height: 120px;
       margin-bottom: 2px;
    }
    .name {
      font-size: 12px;
      color: #BBBBBB;
      line-height: 1.5;
      width: 120px;
      &.active{
        color: #999999;
      }
    }
  }
}
</style>
